// extracted by mini-css-extract-plugin
export default {"stunningFootImage":"StunComp_stunningFootImage__e4Mdw","stunningFootImageGradient":"StunComp_stunningFootImageGradient__AMC0V"};